import { render } from "./ProtpreparationView.vue?vue&type=template&id=4fed49f7&scoped=true"
import script from "./ProtpreparationView.vue?vue&type=script&lang=js"
export * from "./ProtpreparationView.vue?vue&type=script&lang=js"

import "./ProtpreparationView.vue?vue&type=style&index=0&id=4fed49f7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fed49f7"]])

export default __exports__